/**
 * serverConfig — single source of truth for the display (player) app's server
 * connection: API base URL, its origin, the API route prefix, and the derived
 * Socket.IO path. Everything that talks to the backend imports from here so the
 * namespace lives in ONE place.
 */

// Full API base, e.g. "http://host:3100/api/dhive" (from the build-time env).
export const SERVER_BASE_URL = import.meta.env.VITE_SERVER_BASE_URL || "";

// Origin only (scheme://host:port) — used for socket connections and resolving
// root-relative asset/layout paths against the API host.
export const SERVER_ORIGIN = (() => {
  try {
    return new URL(SERVER_BASE_URL).origin;
  } catch {
    return window.location.origin;
  }
})();

// The API route prefix (pathname of the base URL), e.g. "/api/dhive".
export const API_PREFIX = (() => {
  try {
    return new URL(SERVER_BASE_URL).pathname.replace(/\/+$/, "") || "/api/dhive";
  } catch {
    return String(SERVER_BASE_URL || "/api/dhive").replace(/\/+$/, "");
  }
})();

// Socket.IO path — always matches the backend mount.
export const SOCKET_PATH = `${API_PREFIX}/socket.io`;
